import React, { Component } from 'react';
import * as Constants from '../../constants/constants'
import { Container, Card } from 'react-bootstrap';

import Title from './simpleReport/title'
import DocumentInformation from './simpleReport/document-information'
import ValidationPolicy from './simpleReport/validation-policy'
import Signature from './simpleReport/signature'
import i18n from '../../i18n';

const titleStyle = {
	backgroundColor: Constants.MAIN_COLOR,
	color: "#fff",
	fontWeight: "bold",
	fontSize: "18px"
}

export default class SimpleReport extends Component {

	constructor(props) {
		super(props);
		//console.log(this.props.report);
	}

	render() {
		return (
			<div className="container">
				<section>
					<Title reportId={this.props.reportId} />
				</section>
				<br />
				<section>
					<DocumentInformation signature={this.props.report.signature} reportGenerationTime={this.props.reportGenerationTime} permLinkValidUntil={this.props.permLinkValidUntil}
						signaturesCount={this.props.report.signaturesCount} documentName={this.props.documentName}
						hash={this.props.hash} linkId={this.props.linkId} language={this.props.language} />
				</section>
				<br />
				<section>
					<ValidationPolicy data={this.props.report.policy} />
				</section>
				<br />

				{this.props.report.signature.length > 0 ?
					<section>
						<Card.Header style={titleStyle}>
							{i18n.t("docInfo:signatures")}
						</Card.Header>

						{this.props.report.signature.map((signature, i) => {
							return <div key={i}><Signature data={signature} index={i} signaturesCount={this.props.report.signaturesCount} handleKeyUp={this.props.handleKeyUp} /></div>
						})}
					</section>
					:
					null
				}
			</div>
		);
	}
}